import { css } from 'emotion';
export default {
	refresh: css`
		cursor: pointer;
		float: right;
	`,
	viewLbl: css`
		border: none !important;
	`,
	viewSelectorRow: css`
		padding: 10px 0 20px 0;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	`,
	tabsWrapper: css`
		display: flex;
		justify-content: space-between;
		padding-bottom: 20px;
	`,
	buttonsRow: css`
		padding-bottom: 20px;
	`,
	footer: css`
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 10px;
	`,
	formGroup: css`
		flex-wrap: wrap;
		> div.field {
			padding-top: 0.5em;
			padding-bottom: 0.5em;
		}
	`,
	btnAdd: css`
		margin-left: 0px !important;
	`,
	buttonsBottom: css`
		margin-top: 40px !important;
	`,
	btnLink: css`
		margin-top: 15px !important;
		margin-bottom: 15px !important;
	`,
	dropDownRoles: css`
		margin-top: 5px;
		margin-bottom: 25px !important;
	`,
	toggleMargin: css`
		margin-top: 25px !important;
		margin-left: 8px !important;
	`,
	toggleMarginBtm: css`
		margin-bottom: 40px !important;
		margin-top: 20px !important;
		margin-left: 8px !important;
	`,
	clear: css`
		clear: both;
	`
};



// WEBPACK FOOTER //
// ./src/routes/Admin/Prescribers/styles.js